<div class="d-flex w-100">
    <telxl-search
        [searchText]="searchText()"
        (searchTextChange)="searchChanged($event)"
        [disabled]="disabled()"
        id="agent-directory-search"
        class="w-100"
    />
    @if (showMediaFilter()) {
        <div class="ms-2">
            <telxl-dropdown
                size="sm"
                colour="dropdown"
                [outline]="true"
                position="bottom-end"
                [menuItems]="mediaMenuItems"
                [disabled]="disabled()"
                [selected]="media"
                (selectedChange)="media = $event"
            />
        </div>
    }
</div>
<div
    #scrollContainer
    class="scroll-container mt-2"
    [style.height]="calculateHeight()"
    [style.max-height]="calculateHeight()"
>
    @for (listing of listings(); track listing.id) {
        <telxl-shared-directory-listing-item
            [source]="listing.userRole ?? 'agents'"
            [customButtonTemplate]="customButtonTemplate()"
            [item]="listing"
            [mode]="restrictMode(listing)"
            [highlight]="highlight() === listing.id"
            [displayMediaIcons]="displayMediaIcons()"
            [disabled]="disabled()"
            [view]="useOperatorDialing() ? 'none' : 'contact'"
            [selected]="{
                item: selected()?.item ?? [],
                selected: selected()?.id === listing.id,
            }"
            (selectedChange)="selectedChanged($event)"
        />
    } @empty {
        @if (!isLoading()) {
            <div
                class="d-flex flex-column align-items-center justify-content-center h-100"
            >
                <i class="fa-thin fa-face-zipper text-primary"></i>
                <div class="font-xxl mt-4">No data!</div>
                <div class="mt-4">No agents were found.</div>
            </div>
        } @else {
            <div class="h-100 w-100">
                <telxl-loading size="3rem" />
            </div>
        }
    }
</div>
